import { defineComponent as _defineComponent } from 'vue'
import { onClickOutside } from '@vueuse/core'
import { ref } from '@nuxtjs/composition-api'

/**
 * HELLO
 *
 * You should probably go over and check out ModalDialog first!!
 */


export default /*#__PURE__*/_defineComponent({
  __name: 'Modal',
  emits: ["click-outside"],
  setup(__props, { emit }: { emit: ({
  (e: 'click-outside'): void
}), expose: any, slots: any, attrs: any }) {



const modalContent = ref<HTMLDivElement>()

onClickOutside(modalContent, () => {
  emit('click-outside')
})

return { __sfc: true,emit, modalContent }
}

})